import * as React from 'react';
import { IgcCarouselSlideComponent as Component } from 'igniteui-webcomponents';
import { createComponent } from '../react-props.js';

/**
 * A single content container within a set of containers used in the context of an `igc-carousel`.
 * @slot Default - slot for the carousel slide.
 * @class
 */
export const IgrCarouselSlide = /* @__PURE__ */ createComponent({
  tagName: 'igc-carousel-slide',
  displayName: 'IgrCarouselSlide',
  elementClass: Component,
  react: React,
});

export type IgrCarouselSlide = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrCarouselSlideModule = Component;
